module.exports = __webpack_public_path__ + "img/2.2349707b.jpg";